import { useEffect } from "react";

export const SESSION_EXPIRY_WARNING_SECONDS = 90;

const normalizeExpiryMilliseconds = (expiry) => {
  const numericExpiry = Number(expiry);
  if (!Number.isFinite(numericExpiry) || numericExpiry <= 0) return null;

  return numericExpiry < 1_000_000_000_000
    ? numericExpiry * 1000
    : numericExpiry;
};

const useSessionExpiryMonitor = ({
  enabled,
  expiry,
  sessionForcedLogout,
  onWarning,
  onExpired,
  warningSeconds = SESSION_EXPIRY_WARNING_SECONDS,
}) => {
  useEffect(() => {
    if (!enabled || sessionForcedLogout) return undefined;

    const expiryMilliseconds = normalizeExpiryMilliseconds(expiry);
    if (!expiryMilliseconds) return undefined;

    const now = Date.now();
    const warningAt = expiryMilliseconds - warningSeconds * 1000;
    let warningTimer;
    let expiryTimer;

    if (now >= expiryMilliseconds) {
      onExpired();
      return undefined;
    }

    if (now >= warningAt) {
      onWarning();
    } else {
      warningTimer = setTimeout(onWarning, warningAt - now);
    }

    expiryTimer = setTimeout(onExpired, expiryMilliseconds - now);

    return () => {
      if (warningTimer) clearTimeout(warningTimer);
      if (expiryTimer) clearTimeout(expiryTimer);
    };
  }, [
    enabled,
    expiry,
    onExpired,
    onWarning,
    sessionForcedLogout,
    warningSeconds,
  ]);
};

export default useSessionExpiryMonitor;
